"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableSchemaValidator = exports.rowOrderValidator = exports.columnsTableSchemaValidator = exports.columnTableSchemaValidator = exports.summarizeTableSchemaValidator = exports.tableWidgetColumnAdvancedOpts = exports.SummarizeType = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
const tab_1 = require("../../tab");
var SummarizeType;
(function (SummarizeType) {
    SummarizeType["AVG"] = "avg";
    SummarizeType["SUM"] = "sum";
    SummarizeType["COUNT"] = "count";
    SummarizeType["WEIGHTED_AVG"] = "weighted_avg";
})(SummarizeType = exports.SummarizeType || (exports.SummarizeType = {}));
exports.tableWidgetColumnAdvancedOpts = zod_1.z.object({
    rounding: common_1.roundingOpts.default(common_1.DEFAULT_ROUNDING_OPTS),
    prefix: zod_1.z.string().max(20, 'O prefixo deve conter no máximo 20 caracteres').optional(),
});
exports.summarizeTableSchemaValidator = zod_1.z.discriminatedUnion('type', [
    zod_1.z.object({
        type: zod_1.z.literal(SummarizeType.AVG),
    }),
    zod_1.z.object({
        type: zod_1.z.literal(SummarizeType.COUNT),
    }),
    zod_1.z.object({
        type: zod_1.z.literal(SummarizeType.SUM),
    }),
    zod_1.z.object({
        type: zod_1.z.literal(SummarizeType.WEIGHTED_AVG),
        weighted_by_col: zod_1.z.number(),
    }),
]);
exports.columnTableSchemaValidator = zod_1.z.object({
    column_id: zod_1.z.string().min(1),
    column_name: zod_1.z.string().optional(),
    name: zod_1.z.string().optional(),
    summarize: exports.summarizeTableSchemaValidator.optional(),
    advanced_opts: exports.tableWidgetColumnAdvancedOpts.optional(),
});
exports.columnsTableSchemaValidator = zod_1.z.array(exports.columnTableSchemaValidator);
exports.rowOrderValidator = zod_1.z.array(zod_1.z.object({ orderType: zod_1.z.nativeEnum(tab_1.OrderType), colId: zod_1.z.string() }));
exports.tableSchemaValidator = zod_1.z.intersection(common_1.commonTypeSchemaValidator, zod_1.z.object({
    columns: exports.columnsTableSchemaValidator,
    filter: common_1.widgetFilterValidator.optional(),
    defaultOrder: exports.rowOrderValidator.optional(),
}));
